var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    viewBox: "0 0 46 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "social icon for YouTube") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4479 0.958011C42.4012 1.48056 43.944 3.03577 44.4666 5.00156C45.4121 8.55987 45.4121 16 45.4121 16C45.4121 16 45.4121 23.4401 44.4666 26.9984C43.944 28.9642 42.4012 30.5194 40.4479 31.042C36.902 32 22.7061 32 22.7061 32C22.7061 32 8.51011 32 4.96423 31.042C3.01089 30.5194 1.46812 28.9642 0.945565 26.9984C0 23.4401 0 16 0 16C0 16 0 8.55987 0.945565 5.00156C1.46812 3.03577 3.01089 1.48056 4.96423 0.958011C8.51011 0 22.7061 0 22.7061 0C22.7061 0 36.902 0 40.4479 0.958011ZM29.9347 16L18.0653 22.7558V9.24417L29.9347 16Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.8c7a9a73433f3ae7ab350175e9f522bf.svg";
export { ForwardRef as ReactComponent };